import {
  IInvoiceRespSchema,
  PaymentGatewayConfigurations,
} from '@monetize/types/app';
import { FunctionComponent as FC } from 'react';
import { StripeWrapper } from '../../../components/PaymentMethods/Form/StripeWrapper';
import { SharedInvoiceFormFields } from './SharedInvoiceFormFields';

interface SharedInvoicePaymentModalProps {
  allowPartialPayment: boolean;
  clientSecret: string;
  invoice: IInvoiceRespSchema;
  paymentMethodId?: string;
  invoiceSecretId: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  isOpen: boolean;
  publicKey: string;
  tenantId: string;
  paymentConfiguration?: PaymentGatewayConfigurations;
  onClose: () => void;
}

export const SharedInvoicePaymentModal: FC<SharedInvoicePaymentModalProps> = (
  props: SharedInvoicePaymentModalProps,
) => {
  const { publicKey, clientSecret } = props;

  if (!publicKey || !clientSecret) {
    return null;
  }

  return (
    <StripeWrapper apiKey={publicKey} clientSecret={clientSecret}>
      <SharedInvoiceFormFields {...props} setupIntent={clientSecret} />
    </StripeWrapper>
  );
};
